import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00150 = new TileLayer({
  title: 'Máscara 20120915',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120915l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00150.setVisible(false);
  
const layer00149 = new TileLayer({
  title: 'Máscara 20121001',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20121001l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00149.setVisible(false);

const layer00148 = new TileLayer({
  title: 'Máscara 20121017',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20121017l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00148.setVisible(false);

const layer00147 = new TileLayer({
  title: 'Máscara 20130529',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130529l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00147.setVisible(false);

const layer00146 = new TileLayer({
  title: 'Máscara 20130614',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130614l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00146.setVisible(false);
  
const layer00145 = new TileLayer({
  title: 'Máscara 20130622',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130622l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00145.setVisible(false);

const layer00144 = new TileLayer({
  title: 'Máscara 20130630',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130630l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00144.setVisible(false);
  
const layer00143 = new TileLayer({
  title: 'Máscara 20130708',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130708l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00143.setVisible(false);
  
const layer00142 = new TileLayer({
  title: 'Máscara 20130724',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130724l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00142.setVisible(false);
  
const layer00141 = new TileLayer({
  title: 'Máscara 20130809',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130809l8oli202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00141.setVisible(false);

const layer00140 = new TileLayer({
  title: 'Máscara 20130817',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20130817l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00140.setVisible(false);

export const grupoCapa01_9 = new LayerGroup({
  title: 'Ciclo Hidrológico 2012-2013',
  fold: 'close',
  layers: [layer00140, layer00141, layer00142, layer00143, layer00144, layer00145, layer00146, layer00147, layer00148, layer00149, layer00150]
});